import React, { Component } from 'react'
import Legacy from './Legacy'

export default class Recipient extends Component {
  render () {
    return <Legacy {...this.props}/>
  }
}
